import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@accure/ui';

import { AlertStatus } from '@/entities/alert-status';

import { BadgeMinAlertStatus } from '../badge-min-alert-status';

export type SelectMinAlertStatusProps = {
  value: AlertStatus;
  onChange: (value: AlertStatus) => void;
};

export function SelectMinAlertStatus({
  value,
  onChange,
}: SelectMinAlertStatusProps) {
  return (
    <Select onValueChange={onChange} defaultValue={value}>
      <SelectTrigger className="relative !w-[240px]">
        <SelectValue />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {Object.values(AlertStatus)
            .filter((status) => status !== AlertStatus.OK)
            .map((status) => (
              <SelectItem
                key={status}
                value={status.toString()}
                className="py-2.5"
              >
                <BadgeMinAlertStatus minAlertStatus={status} />
              </SelectItem>
            ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  );
}
